/**
 * 定义应用路
 */
import React from 'react';

import KeepAlive, { AliveScope, useAliveController } from 'react-activation';
import { HashRouter as Router, Switch, Route, withRouter } from 'react-router-dom';

import routerConfig from './routerConfig';

// let cacheRouteDirection = {};

let cacheMapReverse = {};
/**
 * 将路由信息扁平化，继承上一级路由的 path
 * @param {Array} config 路由配置
 */
function recursiveRouterConfigV4(config = []) {
  const routeMap = [];
  config.forEach(item => {
    const route = {
      path: item.path,
      layout: item.layout,
      component: item.component,
      authority: item.authority,
      keepAlive: item.keepAlive,
    };
    if (Array.isArray(item.children)) {
      route.childRoutes = recursiveRouterConfigV4(item.children);
    }
    routeMap.push(route);
  });
  return routeMap;
}

/**
 * 将扁平化后的路由信息生成 Route 节点
 *
 * @param {Element} container 路由容器
 * @param {object} router 路由对象
 * @param {string} contextPath 上层路由地址
 * @return {Route}
 * @example
 * <Switch>
 *   <Route exact path="/" component={Home} />
 *   <Route exact path="/page3" component={Page3} />
 *   <Route exact path="/page4" component={Page4} />
 *   <Route exact path="/page3/:id" component={Page3} />
 *   <Route exact component={NotFound} />
 * </Switch>
 */
function renderRouterConfigV4(container, router, contextPath) {
  // eslint-disable-next-line no-unused-vars
  const { clear: clearCache, refreshScope } = useAliveController();
  const routeChildren = [];
  const renderRoute = (routeContainer, routeItem, routeContextPath) => {
    let routePath;
    if (!routeItem.path) {
      console.error('route must has `path`');
    } else if (routeItem.path == '/' || routeItem.path == '*') {
      routePath = routeItem.path;
    } else {
      routePath = `/${routeContextPath}/${routeItem.path}`.replace(/\/+/g, '/');
    }

    // 优先使用当前定义的 layout
    if (routeItem.layout && routeItem.component) {
      routeChildren.push(
        <Route
          key={routePath}
          exact
          path={routePath}
          // 这个props应该是Route组件匹配path成功后的一些基本路径信息
          render={props => {
            // 这里的props就是每个实际页面的props
            // console.log(routePath, props);
            // Object.assign(props, { authority: routeItem.authority })
            const propsWithAuthority = { ...props, authority: routeItem.authority };
            return React.createElement(
              routeItem.layout,
              // TODO: 这里是不是也要写上权限信息？针对没有layout的？
              props,
              // <routeItem.component propsWithAuthority/>
              // routeItem.keepAlive ?
              true ? (
                <KeepAlive
                  name={routePath}
                  when={() => {
                    // eslint-disable-next-line no-unused-vars
                    const { history, location } = props;
                    // console.log('keep', history.location.pathname, routePath, history.action);
                    const destination = routeItem.keepAlive?.destination;
                    const to = history.location.pathname;
                    const from = routePath;

                    // console.log(`keepAlive: from: ${from} action: ${history.action} to: ${to}`)
                    // console.log('keepAlive', cacheRouteDirection);
                    // console.log('keepAlive', cacheMapReverse);

                    // 1. 如果不是从当前目标路由对应的缓存子路由跳转过来的，清空缓存
                    // if(cacheRouteDirection[to] && !(Array.isArray(cacheRouteDirection[to]) ? cacheRouteDirection[to].includes(from) : from === cacheRouteDirection[to])) {
                    //   console.log('keepAlive', '不是从当前目标路由对应的缓存子路由跳转过来的，清空缓存')
                    // 先刷新缓存，再下一个事件周期清空缓存
                    //   refreshScope(to);
                    //   // cacheRouteDirection = {};
                    //   setTimeout(() => {
                    //     clearCache();
                    //   }, 0);
                    // }

                    // 2. 如果跳转的目标路由，不是自己的父路由，则清空缓存
                    if (cacheMapReverse[from] && to !== cacheMapReverse[from]) {
                      // console.log('keepAlive', '转的目标路由，不是自己的父路由，清空缓存');
                      // TODO: 这里目前有些暴力，可进一步细化一下，仅清空关联路由
                      clearCache();
                      cacheMapReverse = {};
                    }

                    // 上面两种方式是两种思路
                    // 第1种是来源判断（进入路由时判断是不是由缓存子路由跳转而来，不是则先刷新当前页面然后清空缓存）
                    // 第2种是目的判断（进入路由时判断是不是其已经缓存的缓存父路由，不是则清空缓存）

                    if (!destination) return false;

                    switch (history.action) {
                      case 'REPLACE':
                      case 'POP': {
                        return false;
                      }
                      case 'PUSH':
                      default: {
                        if (
                          Array.isArray(destination)
                            ? destination.includes(to)
                            : to === routeItem.keepAlive.destination
                        ) {
                          // 记住本次缓存的路由

                          // console.log('keepAlive', '命中了，缓存：'+from);
                          // 1. 记录缓存路由关系 格式为父子 父 -> 子 键值对的形式存储缓存记录，如
                          // {'/basic/dept': ['/basic/dept/edit‘,'/basic/dept/delete'] },
                          // {'/basic/user': '/basic/user/edit'}
                          // cacheRouteDirection[from] = destination;

                          // 2. 记录缓存路由的对应关系，格式为 子 -> 父 键值对的形式存储缓存记录，如
                          // {'/basic/dept/edit', '/basic/dept'},
                          // {'/basic/dept/delet, '/basic/dept'},
                          // {'/basic/user/edit}, '/basic/user'}
                          cacheMapReverse[to] = from;

                          // 被缓存页面离开前（通过点击部分其他路由入口，如菜单），如果页面内有已打开的弹窗，则弹窗由于是被外挂的，会一直留在页面中
                          // 使用一个粗暴的方法：
                          // 判断是否有未关闭弹窗，有的话模拟点击一下body来模拟“点击外部关闭”
                          if (
                            document.getElementsByClassName('next-overlay-wrapper opened').length >
                            0
                          ) {
                            document.body.click();
                          }

                          return true;
                        }
                        return false;
                      }
                    }
                  }}
                  // NOTE: 由于被KeepAlive包裹，如果不加入authority字段会导致路由权限判断失效
                  authority={propsWithAuthority.authority}
                >
                  {React.createElement(routeItem.component, propsWithAuthority)}
                </KeepAlive>
              ) : (
                React.createElement(routeItem.component, propsWithAuthority)
              )
            );
            // <layout props>
            //   <children props/>
            // </layout>
          }}
        />
      );
    } else if (routeContainer && routeItem.component) {
      // 使用上层节点作为 container
      routeChildren.push(
        <Route
          key={routePath}
          exact
          path={routePath}
          render={props => {
            return React.createElement(
              routeContainer,
              props,
              React.createElement(routeItem.component, props)
            );
          }}
        />
      );
    } else {
      routeChildren.push(
        <Route key={routePath} exact path={routePath} component={routeItem.component} />
      );
    }

    // 存在子路由，递归当前路径，并添加到路由中
    if (Array.isArray(routeItem.childRoutes)) {
      routeItem.childRoutes.forEach(r => {
        // 递归传递当前 route.component 作为子节点的 container
        renderRoute(routeItem.component, r, routePath);
      });
    }
  };

  router.forEach(r => {
    renderRoute(container, r, contextPath);
  });

  // Switch组件的作用是给Route组件进行分组，
  // Route组件通过比较它的path属性和当前地址来判断是否渲染它的内容，所以就会存在多个Route匹配成功并渲染的情况，
  // Switch会在挑选出第一个匹配的Route来进行渲染;
  return <Switch>{routeChildren}</Switch>;
}

class ScrollTopTop extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

const routerWithReactRouter4 = recursiveRouterConfigV4(routerConfig);
// const routeChildren = renderRouterConfigV4(null, routerWithReactRouter4, '/');

const RouterChildren = () => {
  return renderRouterConfigV4(null, routerWithReactRouter4, '/', useAliveController);
};
// export default <Router>{routeChildren}</Router>;

const ScrollToTopRouter = withRouter(ScrollTopTop);
export default (
  <Router>
    <ScrollToTopRouter>
      <AliveScope>
        <RouterChildren />
      </AliveScope>
    </ScrollToTopRouter>
  </Router>
);
